<div class="h-100 d-flex flex-column align-items-center justify-content-center">
    <div class="fade-in">
        <img width="300" src="../../../../assets/images/logo-2.png" alt="" />
    </div>

    <br>
    <div class="tagline">
        <p>Automate Your Engineering</p>
    </div>
    <br>
    <div class="dosis msg" *ngIf="showInactiveOrganisation">
        Organisation is not active contact admin ...
    </div>
    <br>
    <div class="dosis msg" *ngIf="showMessage">
        {{message}} ...
    </div>
    <br>
    <div class="dosis msg" *ngIf="showReload && !showInactiveOrganisation && !showMessage">
        Something went wrong try again ...
    </div>
    <br>
    <div *ngIf="showReload">
        <button mat-stroked-button (click)="refreshPage()">Refresh</button>
    </div>
</div>